import { render, staticRenderFns } from "./recruitset.vue?vue&type=template&id=9bdd279a&scoped=true&"
import script from "./recruitset.vue?vue&type=script&lang=js&"
export * from "./recruitset.vue?vue&type=script&lang=js&"
import style0 from "./recruitset.vue?vue&type=style&index=0&id=9bdd279a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bdd279a",
  null
  
)

export default component.exports